import { getRowsFromGraphTagsFileContent } from "@features/administration/products/EditProduct/graphTagsHelper"
import { GraphTagsFormValues } from "@features/administration/products/EditProduct/GraphTagsForm/GraphTagsForm"

export const getDefaultValues = (tagsResponse: string | undefined): GraphTagsFormValues => {
  const rows = getRowsFromGraphTagsFileContent(tagsResponse ?? "")

  const parsedRows = rows.map((row) => ({
    name: row.Name,
    rule: row.Rule,
    description: row.Description ?? "",
  }))

  return { rows: parsedRows }
}
